<p-dialog
  [header]="header + ' auswählen'"
  [modal]="true"
  [(visible)]="displayGroupRelationDialog"
  (onHide)="cancel()"
  [style]="{ width: '80rem' }"
  appendTo="body"
>
  <div *ngIf="displayGroupRelationDialog">
    <jml-lib-entity-group-relation [holderId]="rowData['id']" [relation]="relation"></jml-lib-entity-group-relation>
  </div>
</p-dialog>

<div class="cell-view">
  <div class="inner-view">
    {{ rowData[fieldName] }}
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="GroupCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
  </div>
</div>
